<template>
  <div>
    <MasterLayout>
      <div class="pt-5 pb-3 pl-4 pr-3 dashboard_first_row">
        <div class="row">
          <div class="col-md-8">
            <div class="py-5 pt-5 mb-3 row align-items-center white-bg">
              <div class="col-md-1 remove-right-padding col-center-flex">
                <div class="square-icon-wrapper small sky-bg">
                  <img src="@/assets/img/rating1.png" width="35" />
                </div>
              </div>
              <div class="py-1 col-md-7">
                <h4 class="primary-color font-600">
                  {{ $t("text.staffRatings.title") }}
                </h4>
                <p class="mt-3 light-grey-text">
                  {{ $t("text.staffRatings.description") }}
                </p>
              </div>
              <div class="col-md-4 flexify">
                <vue-ctk-date-time-picker
                  v-model="dateRange"
                  :max-date="maxDate"
                  :range="true"
                  :onlyDate="true"
                  :autoClose="true"
                  :locale="this.$root.$i18n.locale"
                  :color="$store.getters.getDatePickerColor"
                  format="YYYY-MM-DDTHH:mm:ss"
                  formatted="DD/MM/YYYY"
                  :label="$t('text.calendar.selectDate')"
                />
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="py-4 card_container">
              <div class="card__header___text">
                <div>
                  <h3 class="text-center our_branches__header">
                    {{ $t("text.staffRatings.allRec") }}
                  </h3>
                  <div class="mt-3 dealer__icon__wrapper">
                    <div class="text-center dealer__icon__div">
                      <div>
                        <img src="@/assets/img/rating.png" width="35" />
                      </div>
                    </div>
                  </div>
                  <h3 class="mt-2 text-center our_branches__header">
                    {{ dataCount }}
                  </h3>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <section class="pump__details__section_2">
        <div class="row">
          <div class="col-md-3">
            <div class="price_change_input_wrapper">
              <model-select
                :options="staffs"
                v-model="staff"
                :placeholder="$t('text.staffRatings.selectStaff')"
              >
              </model-select>
            </div>
          </div>
        </div>
        <div class="row add_driver_row record__expenses mt-4">
          <div class="col-md-12 col-lg-12">
            <ejs-grid
              v-show="!showLoader"
              ref="dataGrid"
              :created="refreshGrid"
              :allowPaging="true"
              :allowSorting="true"
              :pageSettings="pageSettings"
              :toolbar="toolbar"
              :searchSettings="search"
              :allowTextWrap="true"
              :allowExcelExport="true"
              :allowPdfExport="true"
              :toolbarClick="toolbarClick"
              :locale="usedLang"
            >
              <e-columns>
                <e-column width="100" field="index" headerText="#"></e-column>
                <e-column
                  field="date"
                  width="200"
                  :format="formatOptions"
                  type="date"
                  :headerText="$t('text.salesTransactions.date')"
                ></e-column>
                <e-column
                  width="200"
                  field="staffName"
                  :headerText="$t('text.shiftAssignments.staffName')"
                ></e-column>
                <e-column
                  width="200"
                  field="rateValue"
                  :headerText="$t('text.staffRatings.rateValue')"
                ></e-column>
                <e-column
                  width="150"
                  field="totalSale"
                  :headerText="$t('text.staff.totSale')"
                  format="N2"
                ></e-column>
              </e-columns>
            </ejs-grid>
            <TableLoader :showLoader="showLoader" />
          </div>
        </div>
      </section>
    </MasterLayout>
  </div>
</template>

<script>
import MasterLayout from "@/views/Branch/MasterLayout.vue";
import configObject from "@/config";
import TableLoader from "@/components/tableLoader/index";
import { ModelSelect } from "vue-search-select";
import "vue-search-select/dist/VueSearchSelect.css";

import {
  Page,
  Sort,
  Toolbar,
  Search,
  ExcelExport,
  PdfExport,
} from "@syncfusion/ej2-vue-grids";
import JQuery from "jquery";
let $ = JQuery;

export default {
  title: "Loyalty :: Epump Portal",
  name: "DashboardHome",
  components: {
    MasterLayout,
    TableLoader,
    ModelSelect,
  },
  provide: {
    grid: [Page, Sort, Toolbar, Search, ExcelExport, PdfExport],
  },
  data() {
    return {
      usedLang: this.$store.getters.getLanguage,
      litresForPoint: 0,
      pointValue: 0,
      redeemablePoint: 0,
      isButtonDisabled: false,
      loyaltyDetails: {},
      formatOptions: { type: "date", format: "dd/MM/yyyy" },
      branch: "",
      maxDate: this.$moment(new Date()).format("YYYY-MM-DD"),
      startDate: this.$moment().format("YYYY-MM-DDTHH:mm:ss"),
      endDate: this.$moment().format("YYYY-MM-DDTHH:mm:ss"),
      dateRange: { start: this.startDate, end: this.endDate },
      dataCount: 0,
      showLoader: false,
      staffs: [],
      staff: null,

      pageSettings: {
        pageSizes: [10, 20, 50, 100, 200],
        pageCount: 4,
        pageSize: 10,
      },
      toolbar: ["ExcelExport", "PdfExport", "Search"],
      search: { operator: "contains", ignoreCase: true },
    };
  },
  watch: {
    dateRange: function (newRange) {
      if (
        newRange.start !== null &&
        (newRange.end !== null) & (this.staff !== null)
      ) {
        this.getBranchStaffRatings();
      }
    },
    staff() {
      this.getBranchStaffRatings();
    },
    branch: function (newBranch, oldBranch) {
      if (newBranch.id) {
        this.branchId = this.branch.id;
        if (this.branchId !== null) {
          //   this.getBranchStaffRatings();
          this.getStaffs();
        }
      }
    },
  },
  created() {
    this.$eventHub.$on("branch", (branch) => {
      this.branch = branch;
      document.title = `Branch Ratings:: ${branch.name} Retail Outlet`;
    });
  },
  mounted() {
    this.dateRange.start = this.startDate;
    this.dateRange.end = this.endDate;
    $(".e-input").keyup(function (e) {
      searchFun(e);
    });
    function searchFun(event) {
      var grid = document.getElementsByClassName("e-grid")[0].ej2_instances[0];
      var value = event.target.value;
      grid.search(value);
    }
  },
  methods: {
    getStaffs() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Staff/BranchStaff/${this.branchId}`,
          configObject.authConfig()
        )
        .then((response) => {
          response.data.forEach((el) => {
            (el.text = `${el.firstName} ${el.lastName}`), (el.value = el.id);
          });
          this.staffs = response.data;
        })
        .catch((error) => {});
    },
    toolbarClick(args) {
      switch (args.item.text) {
        case "PDF Export":
          this.$refs.dataGrid.pdfExport();
          break;
        case "Excel Export":
          this.$refs.dataGrid.excelExport();
          break;
      }
    },
    refreshGrid() {
      this.$refs.dataGrid.refresh();
    },
    getBranchStaffRatings() {
      this.showLoader = true;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/TransactionRating/Staff/Breakdown/${this.staff}?StartDate=${this.dateRange.start}&EndDate=${this.dateRange.end}`,
          configObject.authConfig()
        )
        .then((res) => {
          this.showLoader = false;
          res.data.forEach((el, index) => {
            el.index = index + 1;
            el.transactionId = el.transactionId ? el.transactionId : "N/A";
            el.staffName = el.staffName ? el.staffName : "N/A";
            el.totalSale = el.totalSale ? el.totalSale : 0;
          });
          this.$refs.dataGrid.ej2Instances.setProperties({
            dataSource: res.data,
          });
          this.dataCount = res.data.length;
          this.refreshGrid();
        })
        .catch((e) => {
          this.showLoader = false;
        });
    },
    convertThousand(request) {
      if (!isFinite(request)) {
        return "0.00";
      }
      return request
        .toFixed(2)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
};
</script>
